import React, { useState } from 'react'
import { useMedications } from '../../hooks/useMedications'
import { useToast } from '../../contexts/ToastContext'
import { useI18n } from '../../hooks/useI18n'
import ActivityItem, { ActivityItemData } from './ActivityItem'

const TodayHistorySection: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { deleteActivity, todayActivities } = useMedications()
  const { error: showError } = useToast()
  const { t } = useI18n()

  const handleUndo = async (activityId: string) => {
    try {
      // Use the deleteActivity function from context which handles stock restoration
      // and optimistic updates
      await deleteActivity(activityId)
    } catch (error) {
      console.error('❌ Error in undo operation:', error)
      showError(t('error'), t('error-undoing-action'))
    }
  }

  // Convert context activities to history format
  const displayedActivities: ActivityItemData[] = todayActivities.map(activity => ({
    id: activity.id,
    medicationId: activity.medicationId,
    medicationName: activity.medicationName,
    scheduledTime: activity.scheduledTime,
    actualTime: activity.actualTime,
    timestamp: activity.actualTime || activity.createdAt,
    type: activity.type || 'medication_taken',
    status: activity.status,
    stockBefore: activity.stockBefore,
    stockAfter: activity.stockAfter,
    notes: activity.notes
  }))

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 mb-6">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between text-left focus:outline-none"
      >
        <div className="flex items-center">
          <svg className="w-6 h-6 text-primary mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Historial de Hoy</h3>
          {displayedActivities.length > 0 && !isExpanded && (
            <span className="ml-2 bg-primary text-white text-xs px-2 py-1 rounded-full">
              {displayedActivities.length}
            </span>
          )}
        </div>
        <svg
          className={`w-5 h-5 text-gray-500 dark:text-gray-400 transform transition-transform ${isExpanded ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isExpanded && (
        <div className="mt-4">
          {displayedActivities.length === 0 ? (
            <div className="text-center py-6">
              <svg className="mx-auto h-10 w-10 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-gray-500 dark:text-gray-400 text-sm">No hay actividad registrada hoy</p>
            </div>
          ) : (
            <div className="space-y-3">
              {displayedActivities.map((activity) => (
                <ActivityItem
                  key={activity.id}
                  activity={activity}
                  showUndo={true}
                  onUndo={handleUndo}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default TodayHistorySection 